module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/199-sudan-ab18866e5f28ab8fa96c88ff69d78e3e.svg";